import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const VoiceAIRecords = loadable(() => import('./List'), {
  fallback: <FullPageLoader />,
});

